module.exports = __webpack_public_path__ + "img/menucn_4_3.77bd04bc.svg";